import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import lodash, { isArray } from "lodash";
import { URL } from "../url";
//component
import AllowScreen from "../layout/layout_allow";
// import KycScreen from "../layout/layout_kyc";
import { LoadingScreen } from "../../../component/loading";
// redux
import { isLoggedSelector } from "store/bailiff/auth/bailiff_auth.selector";
// import { defaultPaperLastSelector } from "store/bailiff/(default)/paper/default_paper.selector";
import { useClaimToken } from "hook/useToken";

const FLOWS = {
  LOADING: "loading",
  UNLOGGED: "unlogged",
  NOT_ALLOW: "not_allow",
  ALLOWED: "allowed",
};

const PrivateRoute = (props) => {
  // -------------------------- VAR --------------------------
  const { permissions } = useClaimToken();

  let location = useLocation();
  const element = props?.element;
  const require = props?.require;
  // -------------------------- STATE --------------------------
  const [flow, setFlow] = useState(FLOWS.LOADING);
  console.log({ flow });
  // -------------------------- REDUX --------------------------
  const logged = useSelector(isLoggedSelector);
  // const lastKyc = useSelector(defaultPaperLastSelector);
  const diff =
    isArray(require) && isArray(permissions)
      ? lodash.difference(require, permissions)
      : [];
  const allow = diff?.length === 0 ? true : false;
  // const isKyc =
  //   lastKyc?.status === "verified" ? true : lastKyc === "none" ? "none" : false;

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (logged === null) {
      setFlow(FLOWS.LOADING);
    }

    if (allow === false) {
      setFlow(FLOWS.LOADING);
    }

    if (logged === false) {
      setFlow(FLOWS.UNLOGGED);
    }

    if (logged && allow === false) {
      setFlow(FLOWS.NOT_ALLOW);
    }

    if (logged && allow === true) {
      setFlow(FLOWS.ALLOWED);
    }
  }, [allow, logged]);

  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------

  if (flow === FLOWS.LOADING) {
    return <LoadingScreen />;
  }

  if (flow === FLOWS.UNLOGGED) {
    return <Navigate to={URL.home} exact state={{ from: location }} replace />;
  }
  if (flow === FLOWS.NOT_ALLOW) {
    return <AllowScreen />;
  }

  if (flow === FLOWS.ALLOWED) {
    return element;
  }

  return <Navigate to={URL.home} exact state={{ from: location }} replace />;
};

export default PrivateRoute;
